<template>
  <div class="newsList">
    <!-- 新区要闻 -->
    <!-- 内容区 -->
    <div class="content">
      <div class="chanpincon">
        <div class="inner">
          <div class="childnav">
            <div class="desc">
              <img src="/statics/image/index/icon.png" alt />
              <span>{{cateName}}</span>
              <!-- <span>三级分类</span> -->
            </div>
            <el-tabs
              :tab-position="tabPosition"
              v-model="activeName"
              @tab-click="handleClick"
              v-if="cateact"
            >
              <el-tab-pane v-for="(item,index) in cateact" :key="index" :name="item.id.toString()">
                <a
                  href="javascript:scroll(0,0)"
                  v-if="item.link_flag!=1"
                  slot="label"
                  :style="!item.display?'display: none;':''"
                >{{item.title?item.title:''}}</a>
                <a
                  :href="item.url"
                  slot="label"
                  v-if="item.link_flag==1"
                  :style="!item.display?'display: none;':''"
                >{{item.title?item.title:''}}</a>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="news_right">
            <div class="gg_list">
              <div
                class="gg_item"
                v-for="(item,index) in article.articlelist"
                :key="index"
                @click="toInfo(activeName,item.article_id)"
              >
                <div class="gg">
                  <span>[公告] {{item.article_title}}</span>
                </div>
                <div class="time">
                  <span>{{item.publish_at}}</span>
                  <img src="/statics/image/index/gg_jiantou.png" alt />
                </div>
              </div>
            </div>
            <!-- 分页 -->
            <div class="fenye clearfix">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="pages.size"
                layout="prev, pager, next, jumper"
                :total="newsTotal"
                prev-text="上一页"
                next-text="下一页"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cateName: "",
      tabPosition: "left", //导航对齐方式
      activeName: null,
      currentPage: 1, //当前页数
      pages: {
        page: 1,
        size: 10
      },
      newsTotal: 0, //总条数
      nowid: "",
      nowindex: "",
      sanindex: "",
      sanid: "",
      // s_cates: [], //二级分类
      cateact: [],
      article: {},
      fromName: ""
    };
  },
  created() {
    this.nowid = this.$route.query.id;
    this.nowindex = this.$route.query.index;
    this.sanindex = this.$route.query.sanIndex;
    this.sanid = this.$route.query.sanId;
    // this.getCatename();
    this.getNav();
  },
  methods: {
    // getCatename() {
    //   var that = this;
    //   that.$api.index.catelist({}).then(function(res) {
    //     if (res.code == 200) {
    //       // that.cateName =
    //       //   res.result[that.nowindex].s_cates[that.sanindex].title;
    //       for (var i in res.result.all_cate) {
    //         if (res.result.all_cate[i].id == that.nowid) {
    //           for (var j in res.result.all_cate[i].s_cates) {
    //             if (res.result.all_cate[i].s_cates[j].id == that.sanid) {
    //               that.cateName = res.result.all_cate[i].s_cates[j].title;
    //             }
    //           }
    //         }
    //       }
    //     }
    //   });
    // },
    // 获取导航
    getNav() {
      this.nowid = this.$route.query.id;
      this.nowindex = this.$route.query.index;
      this.sanindex = this.$route.query.sanIndex;
      this.sanid = this.$route.query.sanId;
      var that = this;
      var ps = {
        cate_id: that.sanid
      };
      that.$api.index.catelist(ps).then(function(res) {
        if (res.code == 200) {
          that.cateact = res.result.all_cate;
          that.cateName = res.result.cate_name;
          for (var d in res.result.all_cate) {
            if (res.result.all_cate[d].display != 0) {
              that.activeName = res.result.all_cate[d].id.toString();
              if (res.result.all_cate[d].is_child != 1) {
                that.getArticlelist();
              }
              break;
            }
          }
          // if (res.result.all_cate[0].is_child != 1) {
          //   that.getArticlelist();
          // }
        }
      });
    },
    // 文章列表
    getArticlelist() {
      var that = this;
      // console.log(that.activeName,typeof that.activeName);
      var ps = {
        cate_id: that.activeName * 1,
        page: that.pages.page,
        size: that.pages.size,
        keyword: ""
      };
      that.$api.index.articlelist(ps).then(function(res) {
        if (res.code == 200) {
          that.article = res.result;
          that.newsTotal = res.result.total * 1;
        }
      });
    },
    // 导航选中触发
    handleClick(tab, event) {
      // console.log(tab.name);
      // console.log("cateact", this.cateact);
      // 判断是否有三级
      var is_child = 0;
      var link_flag = 0;
      var sanIndex = 0;
      for (var i in this.cateact) {
        if (this.cateact[i].id == tab.name) {
          sanIndex = i;
          is_child = this.cateact[i].is_child;
          link_flag = this.cateact[i].link_flag;
        }
      }
      if (link_flag != 1) {
        if (is_child == 1) {
          this.$router.push({
            path: "/xqNews_sanji",
            query: {
              id: this.nowid,
              index: this.nowindex,
              sanIndex: sanIndex,
              sanId: tab.name
            }
          });
        } else {
          this.getArticlelist();
        }
        this.activeName = tab.name;
        this.currentPage = 1; //当前页数
        this.pages.page = 1;
        // this.getArticlelist();
      }
    },
    // 页数改变时触发
    handleCurrentChange(val) {
      // console.log(val);
      this.pages.page = val;
      this.getArticlelist();
      $("html,body").animate({ scrollTop: 0 }, "slow"); //顶部
    },
    // 点击跳转到新区要闻详情
    toInfo(cate_id, id) {
      // console.log("跳", this.nowindex);
      this.$router.push({
        path: "/xqNews_detail",
        query: {
          cate_id: cate_id,
          id: id,
          index: this.nowindex,
          erId: this.activeName
        }
      });
    }
  },
  watch: {
    $route(to, from) {
      // console.log("to", to.name);
      // console.log("from", from.name);
      // this.fromName = from.name;
      // console.log(from.name != "xqNews_detail");

      // &&from.name != "ztzl"
      if (to.name != "xqNews_detail" && from.name != "xqNews_detail") {
        // console.log("watch");
        this.currentPage = 1; //当前页数
        this.pages.page = 1;
        this.getNav();
      }
      this.article = {};
      this.nowindex = this.$route.query.index;
      this.sanindex = this.$route.query.sanIndex;
      // this.getNav();
    }
  }
  // activated: function() {
  //   console.log("111");
  //   this.currentPage = 1; //当前页数
  //   this.pages.page = 1;
  //   this.getNav();
  // }
};
</script>

<style>
</style>